module.exports = __webpack_public_path__ + "images/pro/payment-wechat-d3eb03de549def8ef0b0875cf9ed2293.png";